import { format, isAfter, isBefore } from 'date-fns';
import * as React from 'react';
import { Anchor, Button, Card, CardContent, CardFooter, Grid, GridColumn, Heading, Notice, Separator, Spinner, Table, TableCell, Text, } from 'telia-front-react';
import { EventContentTooltip } from './EventContentTooltip';
class AddressEventsTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeRows: [],
            showAll: false,
        };
        this.getSearchPath = (type, value) => {
            return `${this.props.getSelfServiceLink('/teenindus/otsing')}?searchType=${type}&searchTerm=${value}`;
        };
        this.triggerTableView = this.triggerTableView.bind(this);
    }
    componentDidMount() {
        this.setState({ activeRows: this.sortTableRows(this.props.addressEvents) });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.addressEvents !== this.props.addressEvents) {
            this.setState({
                showAll: false,
                activeRows: this.sortTableRows(this.props.addressEvents),
            });
        }
    }
    sortTableRows(events) {
        return this.getUniqueByEventType(events.sort(this.sortByCreationDate));
    }
    getUniqueByEventType(events) {
        const reservedIds = [];
        return events.filter((event) => {
            if (!reservedIds.includes(event.eventType.id)) {
                reservedIds.push(event.eventType.id);
                return event;
            }
        });
    }
    sortByCreationDate(a, b) {
        const firstDate = new Date(a.createdAt);
        const secondDate = new Date(b.createdAt);
        if (isAfter(firstDate, secondDate)) {
            return -1;
        }
        if (isBefore(firstDate, secondDate)) {
            return 1;
        }
        if (a.id > b.id) {
            return -1;
        }
        else {
            return 1;
        }
    }
    triggerTableView(e) {
        e.preventDefault();
        this.setState((prevousState) => ({
            showAll: !prevousState.showAll,
            activeRows: prevousState.showAll ? this.sortTableRows(this.props.addressEvents) : this.props.addressEvents,
        }));
    }
    canShowMoreEvents() {
        const { addressEvents } = this.props;
        const { activeRows } = this.state;
        if (!addressEvents || !activeRows) {
            return;
        }
        return this.state.showAll || addressEvents.length !== activeRows.length;
    }
    renderAddNewEventButton(showNoEventsText) {
        const { translate } = this.props.translations;
        const { buttonProps } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['md-12'] },
                    React.createElement(Grid, { align: ['start-md', 'middle-md'] },
                        React.createElement(Button, { ...buttonProps, text: `${translate('addressEvent.table.addNewEvent')}`, url: this.props.newAddressEventUrl, element: "a", target: "_blank" })),
                    showNoEventsText && React.createElement(Text, { className: 'text-center' }, translate('addressEvent.table.noEvents')))),
            React.createElement(Separator, { color: 'invisible', spacing: 'medium' })));
    }
    render() {
        const { translate } = this.props.translations;
        const { showAddNewAddressEvent, showHeading, showEmpty, tableProps, buttonProps, cardProps, providerStatus } = this.props;
        if (providerStatus === 'ERROR') {
            return (React.createElement(Notice, { type: "error", align: "center" }, translate('addressEvent.error')));
        }
        if (providerStatus !== 'FETCHED') {
            return React.createElement(Spinner, null);
        }
        if (!showEmpty && !this.state.activeRows.length) {
            if (showAddNewAddressEvent) {
                return (React.createElement(Card, { type: "employee", padding: "medium", ...cardProps },
                    React.createElement(CardContent, null, this.renderAddNewEventButton(true))));
            }
            else {
                return null;
            }
        }
        return (React.createElement(Card, { type: "employee", padding: "medium", ...cardProps },
            React.createElement(CardContent, null,
                showAddNewAddressEvent && this.renderAddNewEventButton(false),
                showHeading && (React.createElement(Heading, { element: "h2", className: "h3" }, translate('addressEvent.table.heading'))),
                React.createElement(Table, { ...tableProps, responsive: "rows" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement(TableCell, { width: 3, type: "th" }, translate('addressEvent.column.type')),
                            React.createElement(TableCell, { width: 3, type: "th" }, translate('addressEvent.column.content')),
                            React.createElement(TableCell, { width: 3, type: "th" }, translate('addressEvent.column.client')),
                            React.createElement(TableCell, { width: 3, type: "th" }, translate('addressEvent.column.status')))),
                    React.createElement("tbody", null, this.state.activeRows.map((event, idx) => (React.createElement("tr", { key: idx },
                        React.createElement(TableCell, null,
                            React.createElement("p", null, event.eventType.description),
                            React.createElement("p", { className: "text-tiny" },
                                event.createdBy ? `${event.createdBy}, ` : '',
                                format(new Date(event.createdAt), 'dd.MM.yyyy'))),
                        React.createElement(TableCell, null,
                            React.createElement(EventContentTooltip, { content: event.content, index: idx })),
                        React.createElement(TableCell, null,
                            React.createElement("p", null,
                                React.createElement(Anchor, { url: this.getSearchPath('general', `${event.contactFirstName} ${event.contactLastName}`) },
                                    event.contactFirstName,
                                    " ",
                                    event.contactLastName)),
                            React.createElement("p", { className: "text-tiny" },
                                React.createElement(Anchor, { url: this.getSearchPath('phoneNumber', event.contactPhoneNumber) }, event.contactPhoneNumber),
                                event.contactPhoneNumber && event.contactEmail && React.createElement("span", null, ",\u00A0"),
                                React.createElement(Anchor, { url: this.getSearchPath('email', event.contactEmail) }, event.contactEmail)),
                            React.createElement("p", null,
                                React.createElement(Anchor, { url: this.getSearchPath('general', event.contactPersonalCode && event.contactPersonalCode.length > 2 && event.contactPersonalCode.substr(2)) }, event.contactPersonalCode))),
                        React.createElement(TableCell, null, event.eventState.status))))))),
            this.canShowMoreEvents() && (React.createElement(CardFooter, null,
                React.createElement(Button, { url: "#", ...buttonProps, text: `${this.state.showAll ? translate('addressEvent.table.collapse') : translate('addressEvent.table.expand')}`, onClick: this.triggerTableView })))));
    }
}
export { AddressEventsTable };
